import classNames from "classnames";
import { useTranslation } from "react-i18next";

interface SubmitProps {
    isSubmitting?: boolean;
    disabled?: boolean;
    label?: string;
}

const Submit = ({ isSubmitting, disabled, label }: SubmitProps) => {
    const { t } = useTranslation();

    const submitLabel = label ?? t("searchForm.submit");

    return (
        <button
            className={classNames("ancBtn", { disabled })}
            type="submit"
            disabled={disabled}
            data-testid="submit-form"
        >
            {isSubmitting ? t("searchForm.searching") : submitLabel}
        </button>
    );
};
export { Submit };
